import { useParams } from 'react-router-dom';
import { Tile } from 'components/Layout/PageContainer';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { useEffect } from 'react';
import { useBreadcrumbStore } from 'hooks/state/useBreadcrumbStore';
import { BreadcrumbItem } from 'components/breadcrumb/breadcrumbModel';
import { useProductSummary } from 'pages/entities/queryHooks';
import { getErrorMessage } from 'utils/getErrorMessage';
import { EntityPage } from 'pages/entities/components/EntityPage';
import { ProductDetailsSummary } from 'pages/entities/product/ProductDetailsSummary';
import { Filters } from 'services/data.service';
import { useModelService } from 'services/model/model.service';

export function ProductEntityPage() {
  const { productNumber: encodedProductNumber } = useParams();
  const { getAttributes } = useModelService();

  const productNumber = decodeURIComponent(encodedProductNumber ?? '');

  const { data: summaryResponse, error: summaryError } = useProductSummary(productNumber);

  // replace the product number in breadcrumb by the product name when data is loaded
  useEffect(() => {
    const nameSource = summaryResponse;
    if (nameSource && productNumber) {
      const { breadcrumbs, setBreadcrumbs } = useBreadcrumbStore.getState();

      const updateProductBreadcrumb = (items: BreadcrumbItem[]): BreadcrumbItem[] =>
        items.map(item => {
          if (item.path?.includes(productNumber)) {
            return {
              ...item,
              label: nameSource.attributes?.prdName || productNumber,
            };
          }

          return item;
        });

      const updatedBreadcrumbs = updateProductBreadcrumb(breadcrumbs);
      setBreadcrumbs(updatedBreadcrumbs);
    }
  }, [summaryResponse, productNumber]);

  if (!summaryResponse && !summaryError) {
    return <MetricsLoadingSpinner />;
  }

  const filterDecorator = (filters: Filters) => {
    return { ...filters, productNumbers: [productNumber] };
  };

  const availableTables = getAttributes(['chnMarketplace', 'chnCountry', 'styBrandColor', 'artSize', 'artEan']);

  return (
    <EntityPage filterDecorator={filterDecorator} availableTables={availableTables}>
      {summaryError ? (
        <Tile title={productNumber} errorDetails={getErrorMessage(summaryError)} />
      ) : (
        <ProductDetailsSummary response={summaryResponse} />
      )}
    </EntityPage>
  );
}
